"use strict";

var _typeof = require("@babel/runtime-corejs2/helpers/typeof");
var _Reflect$construct = require("@babel/runtime-corejs2/core-js/reflect/construct");
var _WeakMap = require("@babel/runtime-corejs2/core-js/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.array.map.js");
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/taggedTemplateLiteral"));
var _utils = require("@gravity/utils");
var _lodash = require("lodash");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _jsxFileName = "/codebuild/output/src190565674/src/git-codecommit.eu-central-1.amazonaws.com/v1/repos/gravity/apps/tnwi/temp/helpers/ThemeProvider/lib/Dropdown.js",
  _templateObject,
  _templateObject2,
  _templateObject3,
  _templateObject4,
  _templateObject5,
  _templateObject6,
  _templateObject7,
  _templateObject8,
  _templateObject9;
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function cov_19j7qed9vp() {
  var path = "/codebuild/output/src190565674/src/git-codecommit.eu-central-1.amazonaws.com/v1/repos/gravity/apps/tnwi/temp/helpers/ThemeProvider/lib/Dropdown.js";
  var hash = "5e94b4776c4500bf0f79a6e7b8a9b22da546297d";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src190565674/src/git-codecommit.eu-central-1.amazonaws.com/v1/repos/gravity/apps/tnwi/temp/helpers/ThemeProvider/lib/Dropdown.js",
    statementMap: {
      "0": {
        start: {
          line: 7,
          column: 30
        },
        end: {
          line: 12,
          column: 1
        }
      },
      "1": {
        start: {
          line: 14,
          column: 23
        },
        end: {
          line: 17,
          column: 1
        }
      },
      "2": {
        start: {
          line: 19,
          column: 26
        },
        end: {
          line: 23,
          column: 1
        }
      },
      "3": {
        start: {
          line: 25,
          column: 24
        },
        end: {
          line: 39,
          column: 1
        }
      },
      "4": {
        start: {
          line: 41,
          column: 30
        },
        end: {
          line: 53,
          column: 1
        }
      },
      "5": {
        start: {
          line: 55,
          column: 21
        },
        end: {
          line: 66,
          column: 1
        }
      },
      "6": {
        start: {
          line: 68,
          column: 30
        },
        end: {
          line: 83,
          column: 1
        }
      },
      "7": {
        start: {
          line: 85,
          column: 14
        },
        end: {
          line: 101,
          column: 1
        }
      },
      "8": {
        start: {
          line: 103,
          column: 21
        },
        end: {
          line: 108,
          column: 1
        }
      },
      "9": {
        start: {
          line: 112,
          column: 4
        },
        end: {
          line: 112,
          column: 17
        }
      },
      "10": {
        start: {
          line: 113,
          column: 4
        },
        end: {
          line: 113,
          column: 54
        }
      },
      "11": {
        start: {
          line: 115,
          column: 4
        },
        end: {
          line: 118,
          column: 5
        }
      },
      "12": {
        start: {
          line: 120,
          column: 4
        },
        end: {
          line: 120,
          column: 61
        }
      },
      "13": {
        start: {
          line: 121,
          column: 4
        },
        end: {
          line: 121,
          column: 69
        }
      },
      "14": {
        start: {
          line: 122,
          column: 4
        },
        end: {
          line: 122,
          column: 69
        }
      },
      "15": {
        start: {
          line: 123,
          column: 4
        },
        end: {
          line: 123,
          column: 61
        }
      },
      "16": {
        start: {
          line: 124,
          column: 4
        },
        end: {
          line: 124,
          column: 65
        }
      },
      "17": {
        start: {
          line: 128,
          column: 4
        },
        end: {
          line: 128,
          column: 71
        }
      },
      "18": {
        start: {
          line: 132,
          column: 4
        },
        end: {
          line: 132,
          column: 74
        }
      },
      "19": {
        start: {
          line: 136,
          column: 4
        },
        end: {
          line: 142,
          column: 6
        }
      },
      "20": {
        start: {
          line: 137,
          column: 6
        },
        end: {
          line: 137,
          column: 30
        }
      },
      "21": {
        start: {
          line: 138,
          column: 6
        },
        end: {
          line: 140,
          column: 9
        }
      },
      "22": {
        start: {
          line: 141,
          column: 6
        },
        end: {
          line: 141,
          column: 37
        }
      },
      "23": {
        start: {
          line: 146,
          column: 4
        },
        end: {
          line: 148,
          column: 5
        }
      },
      "24": {
        start: {
          line: 147,
          column: 6
        },
        end: {
          line: 147,
          column: 13
        }
      },
      "25": {
        start: {
          line: 150,
          column: 4
        },
        end: {
          line: 150,
          column: 28
        }
      },
      "26": {
        start: {
          line: 154,
          column: 4
        },
        end: {
          line: 154,
          column: 37
        }
      },
      "27": {
        start: {
          line: 158,
          column: 4
        },
        end: {
          line: 158,
          column: 37
        }
      },
      "28": {
        start: {
          line: 162,
          column: 4
        },
        end: {
          line: 162,
          column: 80
        }
      },
      "29": {
        start: {
          line: 162,
          column: 43
        },
        end: {
          line: 162,
          column: 78
        }
      },
      "30": {
        start: {
          line: 166,
          column: 41
        },
        end: {
          line: 166,
          column: 51
        }
      },
      "31": {
        start: {
          line: 167,
          column: 37
        },
        end: {
          line: 167,
          column: 47
        }
      },
      "32": {
        start: {
          line: 168,
          column: 4
        },
        end: {
          line: 195,
          column: 5
        }
      },
      "33": {
        start: {
          line: 180,
          column: 16
        },
        end: {
          line: 189,
          column: 40
        }
      },
      "34": {
        start: {
          line: 199,
          column: 19
        },
        end: {
          line: 202,
          column: 2
        }
      },
      "35": {
        start: {
          line: 204,
          column: 0
        },
        end: {
          line: 209,
          column: 1
        }
      },
      "36": {
        start: {
          line: 211,
          column: 0
        },
        end: {
          line: 216,
          column: 1
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 111,
            column: 2
          },
          end: {
            line: 111,
            column: 3
          }
        },
        loc: {
          start: {
            line: 111,
            column: 21
          },
          end: {
            line: 125,
            column: 3
          }
        },
        line: 111
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 127,
            column: 2
          },
          end: {
            line: 127,
            column: 3
          }
        },
        loc: {
          start: {
            line: 127,
            column: 22
          },
          end: {
            line: 129,
            column: 3
          }
        },
        line: 127
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 131,
            column: 2
          },
          end: {
            line: 131,
            column: 3
          }
        },
        loc: {
          start: {
            line: 131,
            column: 25
          },
          end: {
            line: 133,
            column: 3
          }
        },
        line: 131
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 135,
            column: 2
          },
          end: {
            line: 135,
            column: 3
          }
        },
        loc: {
          start: {
            line: 135,
            column: 29
          },
          end: {
            line: 143,
            column: 3
          }
        },
        line: 135
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 136,
            column: 11
          },
          end: {
            line: 136,
            column: 12
          }
        },
        loc: {
          start: {
            line: 136,
            column: 17
          },
          end: {
            line: 142,
            column: 5
          }
        },
        line: 136
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 145,
            column: 2
          },
          end: {
            line: 145,
            column: 3
          }
        },
        loc: {
          start: {
            line: 145,
            column: 24
          },
          end: {
            line: 151,
            column: 3
          }
        },
        line: 145
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 153,
            column: 2
          },
          end: {
            line: 153,
            column: 3
          }
        },
        loc: {
          start: {
            line: 153,
            column: 39
          },
          end: {
            line: 155,
            column: 3
          }
        },
        line: 153
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 157,
            column: 2
          },
          end: {
            line: 157,
            column: 3
          }
        },
        loc: {
          start: {
            line: 157,
            column: 21
          },
          end: {
            line: 159,
            column: 3
          }
        },
        line: 157
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 161,
            column: 2
          },
          end: {
            line: 161,
            column: 3
          }
        },
        loc: {
          start: {
            line: 161,
            column: 25
          },
          end: {
            line: 163,
            column: 3
          }
        },
        line: 161
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 162,
            column: 18
          },
          end: {
            line: 162,
            column: 19
          }
        },
        loc: {
          start: {
            line: 162,
            column: 43
          },
          end: {
            line: 162,
            column: 78
          }
        },
        line: 162
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 165,
            column: 2
          },
          end: {
            line: 165,
            column: 3
          }
        },
        loc: {
          start: {
            line: 165,
            column: 11
          },
          end: {
            line: 196,
            column: 3
          }
        },
        line: 165
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 179,
            column: 27
          },
          end: {
            line: 179,
            column: 28
          }
        },
        loc: {
          start: {
            line: 180,
            column: 16
          },
          end: {
            line: 189,
            column: 40
          }
        },
        line: 180
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 146,
            column: 4
          },
          end: {
            line: 148,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 146,
            column: 4
          },
          end: {
            line: 148,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 146
      },
      "1": {
        loc: {
          start: {
            line: 172,
            column: 13
          },
          end: {
            line: 172,
            column: 42
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 172,
            column: 13
          },
          end: {
            line: 172,
            column: 27
          }
        }, {
          start: {
            line: 172,
            column: 31
          },
          end: {
            line: 172,
            column: 42
          }
        }],
        line: 172
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "5e94b4776c4500bf0f79a6e7b8a9b22da546297d"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_19j7qed9vp = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_19j7qed9vp();
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? _Reflect$construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var resetButtonStyleMixin = (cov_19j7qed9vp().s[0]++, (0, _styledComponents.css)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  background: none;\n  border: none;\n  padding-inline: 0;\n  cursor: pointer;\n"]))));
var dropdownBorder = (cov_19j7qed9vp().s[1]++, (0, _styledComponents.css)(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n  border: 1px solid #696969;\n  overflow: hidden;\n"]))));
var DropdownContainer = (cov_19j7qed9vp().s[2]++, _styledComponents.default.div.attrs({
  className: 'stx-ThemeSelector-DropdownContainer'
})(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2.default)(["\n  position: relative;\n"]))));
var DropdownTrigger = (cov_19j7qed9vp().s[3]++, _styledComponents.default.button.attrs({
  className: 'stx-ThemeSelector-DropdownTrigger',
  type: 'button'
})(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2.default)(["\n  ", ";\n  ", "\n  --trigger-padding-x: 12px;\n  --trigger-padding-y: 8px;\n  padding: var(--trigger-padding-y) var(--trigger-padding-x);\n  background: #f8f8ff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n"])), resetButtonStyleMixin, dropdownBorder));
var DropdownMenuContainer = (cov_19j7qed9vp().s[4]++, _styledComponents.default.div.attrs({
  className: 'stx-ThemeSelector-DropdownMenuContainer'
})(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2.default)(["\n  --menu-container-padding-y: 4px;\n  padding: var(--menu-container-padding-y) 0;\n  position: absolute;\n  left: 0;\n  min-width: 100%;\n\n  &.hidden {\n    display: none;\n  }\n"]))));
var DropdownMenu = (cov_19j7qed9vp().s[5]++, _styledComponents.default.ul.attrs({
  className: 'stx-ThemeSelector-DropdownMenu'
})(_templateObject6 || (_templateObject6 = (0, _taggedTemplateLiteral2.default)(["\n  ", "\n  list-style-type: none;\n  margin-block-start: 0;\n  margin-block-end: 0;\n  margin-inline-start: 0;\n  margin-inline-end: 0;\n  padding-inline-start: 0;\n  background: #f8f8ff;\n"])), dropdownBorder));
var DropdownItemContainer = (cov_19j7qed9vp().s[6]++, _styledComponents.default.li.attrs({
  className: 'stx-ThemeSelector-DropdownItemContainer'
})(_templateObject7 || (_templateObject7 = (0, _taggedTemplateLiteral2.default)(["\n  --item-padding-x: 12px;\n  --item-padding-y: 4px;\n  padding: var(--item-padding-y) var(--item-padding-x);\n  cursor: pointer;\n\n  &.highlight {\n    background: #d3d3d3;\n  }\n\n  :hover {\n    background: #bebebe;\n  }\n"]))));
var Caret = (cov_19j7qed9vp().s[7]++, _styledComponents.default.span.attrs({
  className: 'stx-ThemeSelector-DropdownCaret'
})(_templateObject8 || (_templateObject8 = (0, _taggedTemplateLiteral2.default)(["\n  --font-size: 12px;\n  --icon-size: calc(var(--font-size) / 2);\n  border-left: solid var(--icon-size) transparent;\n  border-right: solid var(--icon-size) transparent;\n  border-top: solid var(--icon-size) black;\n  height: 0;\n  width: 0;\n\n  transition: transform ease-in-out .5s;\n\n  &.up {\n    transform: rotateZ(180deg);\n  }\n"]))));
var DropdownItem = (cov_19j7qed9vp().s[8]++, _styledComponents.default.span.attrs({
  className: 'stx-ThemeSelector-DropdownItem'
})(_templateObject9 || (_templateObject9 = (0, _taggedTemplateLiteral2.default)(["\n  display: block;\n  min-width: max-content;\n"]))));
var Dropdown = /*#__PURE__*/function (_React$Component) {
  function Dropdown(props) {
    var _this;
    (0, _classCallCheck2.default)(this, Dropdown);
    cov_19j7qed9vp().f[0]++;
    cov_19j7qed9vp().s[9]++;
    _this = _callSuper(this, Dropdown, [props]);
    cov_19j7qed9vp().s[10]++;
    _this.dropdownContainerRef = /*#__PURE__*/_react.default.createRef(null);
    cov_19j7qed9vp().s[11]++;
    _this.state = {
      selected: _this.props.value,
      optionsVisible: false
    };
    cov_19j7qed9vp().s[12]++;
    _this.onClickHandlerOf = _this.onClickHandlerOf.bind(_this);
    cov_19j7qed9vp().s[13]++;
    _this.toggleOptionsVisible = _this.toggleOptionsVisible.bind(_this);
    cov_19j7qed9vp().s[14]++;
    _this.changeOptionsVisible = _this.changeOptionsVisible.bind(_this);
    cov_19j7qed9vp().s[15]++;
    _this.closeOptionsMenu = _this.closeOptionsMenu.bind(_this);
    cov_19j7qed9vp().s[16]++;
    _this.handleClickOutSide = _this.handleClickOutSide.bind(_this);
    return _this;
  }
  (0, _inherits2.default)(Dropdown, _React$Component);
  return (0, _createClass2.default)(Dropdown, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      cov_19j7qed9vp().f[1]++;
      cov_19j7qed9vp().s[17]++;
      document.addEventListener('click', this.handleClickOutSide, false);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      cov_19j7qed9vp().f[2]++;
      cov_19j7qed9vp().s[18]++;
      document.removeEventListener('click', this.handleClickOutSide, false);
    }
  }, {
    key: "onClickHandlerOf",
    value: function onClickHandlerOf(selected) {
      var _this2 = this;
      cov_19j7qed9vp().f[3]++;
      cov_19j7qed9vp().s[19]++;
      return function () {
        var _this2$props$onChange, _this2$props;
        cov_19j7qed9vp().f[4]++;
        cov_19j7qed9vp().s[20]++;
        _this2.closeOptionsMenu();
        cov_19j7qed9vp().s[21]++;
        _this2.setState({
          selected: selected
        });
        cov_19j7qed9vp().s[22]++;
        (_this2$props$onChange = (_this2$props = _this2.props).onChange) === null || _this2$props$onChange === void 0 || _this2$props$onChange.call(_this2$props, selected);
      };
    }
  }, {
    key: "handleClickOutSide",
    value: function handleClickOutSide(e) {
      var _this$dropdownContain;
      cov_19j7qed9vp().f[5]++;
      cov_19j7qed9vp().s[23]++;
      if ((_this$dropdownContain = this.dropdownContainerRef.current) !== null && _this$dropdownContain !== void 0 && _this$dropdownContain.contains(e.target)) {
        cov_19j7qed9vp().b[0][0]++;
        cov_19j7qed9vp().s[24]++;
        return;
      } else {
        cov_19j7qed9vp().b[0][1]++;
      }
      cov_19j7qed9vp().s[25]++;
      this.closeOptionsMenu();
    }
  }, {
    key: "changeOptionsVisible",
    value: function changeOptionsVisible(optionsVisible) {
      cov_19j7qed9vp().f[6]++;
      cov_19j7qed9vp().s[26]++;
      this.setState({
        optionsVisible: optionsVisible
      });
    }
  }, {
    key: "closeOptionsMenu",
    value: function closeOptionsMenu() {
      cov_19j7qed9vp().f[7]++;
      cov_19j7qed9vp().s[27]++;
      this.changeOptionsVisible(false);
    }
  }, {
    key: "toggleOptionsVisible",
    value: function toggleOptionsVisible() {
      cov_19j7qed9vp().f[8]++;
      cov_19j7qed9vp().s[28]++;
      this.setState(function (_ref) {
        var optionsVisible = _ref.optionsVisible;
        cov_19j7qed9vp().f[9]++;
        cov_19j7qed9vp().s[29]++;
        return {
          optionsVisible: !optionsVisible
        };
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      cov_19j7qed9vp().f[10]++;
      var _ref2 = (cov_19j7qed9vp().s[30]++, this.state),
        selected = _ref2.selected,
        optionsVisible = _ref2.optionsVisible;
      var _ref3 = (cov_19j7qed9vp().s[31]++, this.props),
        placeHolder = _ref3.placeHolder,
        options = _ref3.options;
      cov_19j7qed9vp().s[32]++;
      return /*#__PURE__*/_react.default.createElement(DropdownContainer, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 169,
          columnNumber: 7
        }
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "stx-ThemeSelector-ContainerRef",
        ref: this.dropdownContainerRef,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 170,
          columnNumber: 9
        }
      }, /*#__PURE__*/_react.default.createElement(DropdownTrigger, {
        onClick: this.toggleOptionsVisible,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 171,
          columnNumber: 11
        }
      }, (cov_19j7qed9vp().b[1][0]++, selected.label) || (cov_19j7qed9vp().b[1][1]++, placeHolder), /*#__PURE__*/_react.default.createElement(Caret, {
        className: (0, _utils.classNames)({
          'up': optionsVisible
        }),
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 173,
          columnNumber: 13
        }
      })), /*#__PURE__*/_react.default.createElement(DropdownMenuContainer, {
        className: (0, _utils.classNames)({
          'hidden': !optionsVisible
        }),
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 175,
          columnNumber: 11
        }
      }, /*#__PURE__*/_react.default.createElement(DropdownMenu, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 178,
          columnNumber: 13
        }
      }, options.map(function (item) {
        cov_19j7qed9vp().f[11]++;
        cov_19j7qed9vp().s[33]++;
        return /*#__PURE__*/_react.default.createElement(DropdownItemContainer, {
          key: item.value,
          className: (0, _utils.classNames)({
            'highlight': (0, _lodash.isEqual)(item, selected)
          }),
          onClick: _this3.onClickHandlerOf(item),
          __self: _this3,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 180,
            columnNumber: 17
          }
        }, /*#__PURE__*/_react.default.createElement(DropdownItem, {
          __self: _this3,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 186,
            columnNumber: 19
          }
        }, item.label));
      })))));
    }
  }]);
}((_react.default.Component));
var OptionType = (cov_19j7qed9vp().s[34]++, _propTypes.default.shape({
  label: _propTypes.default.string,
  value: _propTypes.default.string
}));
cov_19j7qed9vp().s[35]++;
Dropdown.propTypes = {
  options: _propTypes.default.arrayOf(OptionType),
  value: OptionType,
  onChange: _propTypes.default.func,
  placeHolder: _propTypes.default.string
};
cov_19j7qed9vp().s[36]++;
Dropdown.defaultProps = {
  options: [],
  value: null,
  onChange: null,
  placeHolder: 'Select value'
};
var _default = exports.default = Dropdown;